import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EnumResponse } from '../models';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { PageCiselnik } from '../models';
// @ts-ignore
import { PageCiselnikBasicResponse } from '../models';
/**
 * EnumeraciaApi - axios parameter creator
 * @export
 */
export const EnumeraciaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * fetch list of enumerations (RSQL, Pageable)
         * @summary fetch list of Enumerations
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllEnumerationsEnumeracia: async (page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portal/enumeracia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find valid values in enumName by name (RSQL, Pageable)
         * @summary Universal endpoint for Enumeration response
         * @param {string} menoEnumeracia 
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEnumerationByNameEnumeracia: async (menoEnumeracia: string, rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'menoEnumeracia' is not null or undefined
            assertParamExists('findEnumerationByNameEnumeracia', 'menoEnumeracia', menoEnumeracia)
            const localVarPath = `/portal/enumeracia/{menoEnumeracia}`
                .replace(`{${"menoEnumeracia"}}`, encodeURIComponent(String(menoEnumeracia)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (rsql !== undefined) {
                localVarQueryParameter['rsql'] = rsql;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get item of enumeration by id
         * @summary get value by id
         * @param {string} menoEnumeracia 
         * @param {string} kod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnumerationItemByNameAndKodEnumeracia: async (menoEnumeracia: string, kod: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'menoEnumeracia' is not null or undefined
            assertParamExists('getEnumerationItemByNameAndKodEnumeracia', 'menoEnumeracia', menoEnumeracia)
            // verify required parameter 'kod' is not null or undefined
            assertParamExists('getEnumerationItemByNameAndKodEnumeracia', 'kod', kod)
            const localVarPath = `/portal/enumeracia/{menoEnumeracia}/kod/{kod}`
                .replace(`{${"menoEnumeracia"}}`, encodeURIComponent(String(menoEnumeracia)))
                .replace(`{${"kod"}}`, encodeURIComponent(String(kod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnumeraciaApi - functional programming interface
 * @export
 */
export const EnumeraciaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnumeraciaApiAxiosParamCreator(configuration)
    return {
        /**
         * fetch list of enumerations (RSQL, Pageable)
         * @summary fetch list of Enumerations
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllEnumerationsEnumeracia(page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCiselnik>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllEnumerationsEnumeracia(page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find valid values in enumName by name (RSQL, Pageable)
         * @summary Universal endpoint for Enumeration response
         * @param {string} menoEnumeracia 
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEnumerationByNameEnumeracia(menoEnumeracia: string, rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCiselnikBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEnumerationByNameEnumeracia(menoEnumeracia, rsql, page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get item of enumeration by id
         * @summary get value by id
         * @param {string} menoEnumeracia 
         * @param {string} kod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnumerationItemByNameAndKodEnumeracia(menoEnumeracia: string, kod: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnumerationItemByNameAndKodEnumeracia(menoEnumeracia, kod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnumeraciaApi - factory interface
 * @export
 */
export const EnumeraciaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnumeraciaApiFp(configuration)
    return {
        /**
         * fetch list of enumerations (RSQL, Pageable)
         * @summary fetch list of Enumerations
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllEnumerationsEnumeracia(page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageCiselnik> {
            return localVarFp.findAllEnumerationsEnumeracia(page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Find valid values in enumName by name (RSQL, Pageable)
         * @summary Universal endpoint for Enumeration response
         * @param {string} menoEnumeracia 
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEnumerationByNameEnumeracia(menoEnumeracia: string, rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageCiselnikBasicResponse> {
            return localVarFp.findEnumerationByNameEnumeracia(menoEnumeracia, rsql, page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Get item of enumeration by id
         * @summary get value by id
         * @param {string} menoEnumeracia 
         * @param {string} kod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnumerationItemByNameAndKodEnumeracia(menoEnumeracia: string, kod: string, options?: any): AxiosPromise<EnumResponse> {
            return localVarFp.getEnumerationItemByNameAndKodEnumeracia(menoEnumeracia, kod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnumeraciaApi - object-oriented interface
 * @export
 * @class EnumeraciaApi
 * @extends {BaseAPI}
 */
export class EnumeraciaApi extends BaseAPI {
    /**
     * fetch list of enumerations (RSQL, Pageable)
     * @summary fetch list of Enumerations
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumeraciaApi
     */
    public findAllEnumerationsEnumeracia(page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return EnumeraciaApiFp(this.configuration).findAllEnumerationsEnumeracia(page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find valid values in enumName by name (RSQL, Pageable)
     * @summary Universal endpoint for Enumeration response
     * @param {string} menoEnumeracia 
     * @param {string} [rsql] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumeraciaApi
     */
    public findEnumerationByNameEnumeracia(menoEnumeracia: string, rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return EnumeraciaApiFp(this.configuration).findEnumerationByNameEnumeracia(menoEnumeracia, rsql, page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get item of enumeration by id
     * @summary get value by id
     * @param {string} menoEnumeracia 
     * @param {string} kod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumeraciaApi
     */
    public getEnumerationItemByNameAndKodEnumeracia(menoEnumeracia: string, kod: string, options?: AxiosRequestConfig) {
        return EnumeraciaApiFp(this.configuration).getEnumerationItemByNameAndKodEnumeracia(menoEnumeracia, kod, options).then((request) => request(this.axios, this.basePath));
    }
}
